import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("countingareaConfig", () => ({
    templateUrl: "components/trackingzone/countingarea-config.html",
    controller: "countingareaConfigCtrl",

    scope: {
      isOpen: "=",
      selectedItem: "=",
    },
  }))
